import axios from 'axios';
import { API_URL } from '../config';

let currencyPromise;

export const fetchCurrency = () => {
  if (!currencyPromise) {
    const URL = `${API_URL}/currency`;
    currencyPromise = axios(URL, {
      method: 'GET',
    }).then((response) => response.data);
  }
  return currencyPromise;
};

export default fetchCurrency;
